import { useEffect, useState } from "react";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { FormValues } from ".";
import { useAppSelector } from "../../../store/hooks";

interface Props {
  register: any;
  setValue: any;
  phone: any;
}
const Phoneinput = ({ register, setValue, phone }: Props) => {
  setValue("phone", phone);
  const [statePhone, setStatePhone] = useState<any>(phone);
  const { onChange: onChangePhone, ...restPhone } = register("phone");

  const phoneFormatter = (cadena: string) => {
    let phoneArray = cadena.split("");
    let phoneFormatted = phoneArray.map((item, index) => {
      if ((index === 3 || index === 6) && item !== "-") {
        return "-" + item;
      }
      return item;
    });
    return phoneFormatted.join("");
  };

  const handleChangePhone = (e: React.FormEvent<HTMLInputElement>) => {
    let valueFormattedNumber = e.currentTarget.value.split("-").join("");

    let verifynumber = valueFormattedNumber.match(/^[0-9]+$/);

    if (valueFormattedNumber.length <= 10 && verifynumber) {
      let value_add = phoneFormatter(valueFormattedNumber);
      setStatePhone(value_add);
      setValue("phone", value_add);
    } else if (valueFormattedNumber.length === 0) {
      setStatePhone("");
    }
  };

  useEffect(() => {
    setValue("phone", phone);
    setStatePhone(phone);
  }, [phone]);
  return (
    <div className="c-input">
      <div className="c-input__header">
        <span className="c-input__title">Phone</span>
      </div>
      <input
        type="text"
        className="c-input__input"
        value={statePhone}
        onChange={handleChangePhone}
        {...restPhone}
      />
    </div>
  );
};
export default Phoneinput;
